'use strict';

var chunkFYGG567E_js = require('./chunk-FYGG567E.js');
var chunkWNNKWDCR_js = require('./chunk-WNNKWDCR.js');
var chunkTRTE636W_js = require('./chunk-TRTE636W.js');
var chunkATB4Z7GO_js = require('./chunk-ATB4Z7GO.js');
var chunkHUKGHOBJ_js = require('./chunk-HUKGHOBJ.js');
var o = require('react');
var n = require('styled-components');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var o__default = /*#__PURE__*/_interopDefault(o);
var n__default = /*#__PURE__*/_interopDefault(n);

var S=n__default.default.div`
  display: flex;
  flex-direction: column;
  padding: ${({$linkStyleConfig:t})=>t.navbarDropdownPadding};
`,b=n__default.default.div`
  display: grid;
  grid-auto-flow: column;
  grid-template-columns: ${({$linkStyleConfig:t})=>`repeat(3, minmax(${t.gridSize}, 1fr))`};
  grid-template-rows: ${({$linkStyleConfig:t})=>`repeat(6, minmax(${t.minGridSize}, ${t.gridSize}))`};
  grid-gap: 10px;
  padding-top: ${({$linkStyleConfig:t})=>t.navbarDropdownResultPaddingTop};
  height: ${({$linkStyleConfig:t})=>t.navbarDropdownResultHeight};
`,v=n__default.default.div`
  width: ${({$linkStyleConfig:t})=>t.listOptionWidth};
  margin-bottom: ${({$linkStyleConfig:t})=>t.listOptionMarginBottom};
  margin-right: ${({$linkStyleConfig:t})=>t.listOptionMarginRight};
`,x=n__default.default.a`
  text-decoration: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
`,h=({heading:t,links:r})=>{let{tokens:i}=chunkHUKGHOBJ_js.b(),{linkStyling:e}=chunkWNNKWDCR_js.a(i);return o__default.default.createElement(S,{$linkStyleConfig:e},o__default.default.createElement(chunkTRTE636W_js.a,{isBold:!0,level:3,color:i.text_default_text_primary},t),o__default.default.createElement(b,{$linkStyleConfig:e},(r==null?void 0:r.length)>0&&(r==null?void 0:r.map(g=>{let{title:a="",url:s="",suffixIcon:f=o__default.default.createElement(chunkFYGG567E_js.a,{rotateBy:315,size:"16px"})}=g||{};return o__default.default.createElement(v,{key:a,$linkStyleConfig:e},o__default.default.createElement(x,{href:s,target:"_blank"},o__default.default.createElement(chunkATB4Z7GO_js.a,{color:i.text_default_text_primary},a),f))}))))};

exports.a = h;
